<template>
  <div :class="`status--${type}`" class="status">
    <img :src="icon" class="img" alt="" width="24" height="24" >
  </div>
</template>

<script>
const icons = {
  failed: '/svg/history/failed.svg',
  progress: '/svg/history/progress.svg',
  interrupted: '/svg/history/interrupted.svg',
  duplicate: '/svg/history/duplicate.svg',
  success: '/svg/history/success.svg'
}

export default {
  props: {
    type: {
      type: String,
      validator: (prop) =>
        [
          'failed',
          'progress',
          'interrupted',
          'duplicate',
          'success'
        ].includes(prop),
      required: true
    }
  },
  computed: {
    icon () {
      return icons[this.type]
    }
  }
}
</script>

<style lang="scss" scoped>
.status {
  @include size(32px);
  @include center-content;
  border-radius: 50%;

  img {
    @include size(16px);
  }

  &--failed {
    background-color: $status-failed;
  }

  &--success {
    background-color: $status-success;
  }

  &--interrupted {
    background-color: $status-interrupted;
  }

  &--progress {
    background-color: $status-progress;

    animation: rotate 1.5s infinite both linear;
  }

  &--duplicate {
    background-color: $status-duplicate;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
